import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import { useLocalContext } from "../../context/LocalContext";

const Footer = () => {
  const { webinfo = {} } = useLocalContext();
  const year = new Date().getFullYear();

  return (
    <footer className="ft-blue">
      <div className="ft-wrap">
        <div className="ft-top">

          {/* BRAND */}
          <section className="ft-brand">
            <div className="ft-logo">
              {webinfo.logowhite ? (
                <img src={webinfo.logowhite} alt={webinfo.name || "Brand"} />
              ) : (
                <h2 className="ft-brand-text">
                  {webinfo.name || "webantidigi.com"}
                </h2>
              )}
            </div>

            <p className="ft-desc">
              We help brands grow through strategy, design, development, and
              performance marketing with a clear execution process.
            </p>

            <div className="ft-tags">
              <span>Strategy-led delivery</span>
              <span>Conversion focus</span>
              <span>Data-informed decisions</span>
              <span>Long-term partnership</span>
            </div>

            <form
              className="ft-news"
              onSubmit={(e) => {
                e.preventDefault();
                const email = e.target.email.value;
                window.location.href = `mailto:${webinfo.email}?subject=Subscribe&body=Add ${email}`;
              }}
            >
              <input
                name="email"
                type="email"
                placeholder="you@company.com"
                required
              />
              <button type="submit" className="ft-btn">
                Join updates
              </button>
            </form>
          </section>

          {/* SERVICES */}
          <nav className="ft-col">
            <h4>Services</h4>
            <ul>
              <li><Link to="/services">All services</Link></li>
              <li><Link to="/services/ui-ux-design">UX Strategy &amp; Web Design</Link></li>
              <li><Link to="/services/web-development">Web Development</Link></li>
              <li><Link to="/services/search-engine-optimization">SEO &amp; Organic Growth</Link></li>
              <li><Link to="/services/social-media-marketing">Social Content &amp; Growth</Link></li>
              <li><Link to="/services/search-engine-marketing">Performance Ads &amp; Lead Gen</Link></li>
              <li><Link to="/services/local-business-growth">Local SEO &amp; Visibility</Link></li>
              <li><Link to="/process">Process</Link></li>
            </ul>
          </nav>

          {/* COMPANY */}
          <nav className="ft-col">
            <h4>Company</h4>
            <ul>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/our-strategies">Strategy</Link></li>
              <li><Link to="/contact">Contact</Link></li>
              <li><Link to="/services">Solutions</Link></li>
            </ul>
          </nav>

          {/* CONTACT */}
          <section className="ft-contact">
            <h4>Contact</h4>
            <div className="ft-card">
              <div className="ft-row">
                <span className="ft-k">EMAIL</span>
                <a className="ft-v" href={`mailto:${webinfo.email}`}>
                  {webinfo.email || "contact@webantidigi.com"}
                </a>
              </div>

              <div className="ft-row">
                <span className="ft-k">PHONE</span>
                <a className="ft-v" href={`tel:${webinfo.phonecall}`}>
                  {webinfo.phone || "+91 80000 00000"}
                </a>
              </div>

              <div className="ft-row">
                <span className="ft-k">HOURS</span>
                <span className="ft-v">
                  {webinfo.hours || "Mon–Sat · 10am–7pm IST"}
                </span>
              </div>

              <div className="ft-social">
                <a href={webinfo.linkedin || "#"}>in</a>
                <a href={webinfo.twitter || "#"}>X</a>
                <a href={webinfo.instagram || "#"}>IG</a>
              </div>
            </div>
          </section>

        </div>

        {/* BOTTOM */}
        <div className="ft-bottom">
          <p>© {year} {webinfo.name || "webantidigi.com"}. All rights reserved.</p>
          <div className="ft-legal">
            <Link to="/terms-and-conditions">Terms</Link>
            <Link to="/privacy-policy">Privacy</Link>
            <Link to="/refund-policy">Refund Policy</Link>
            <Link to="/shipping-policy">Shipping Policy</Link>
            <Link to="/disclaimer">Disclaimer</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
